<template>
  <v-app>
    <v-navigation-drawer
      v-model="menu.visible"
      :mini-variant.sync="menu.mini"
      app
      clipped
      v-if="this.$store.getters.isAuthenticated"
    >
      <Menu />
    </v-navigation-drawer>

    <v-app-bar v-if="this.$store.getters.isAuthenticated" app clipped-left>
      <v-app-bar-nav-icon @click.stop="menu.visible = !menu.visible" />
      <v-toolbar-title>Plan4Trip</v-toolbar-title>
      <!-- <v-spacer></v-spacer>
      <v-avatar size="36px">
        <img height="85" src="@/assets/logo.png" />
      </v-avatar> -->
    </v-app-bar>

    <!-- DONT TOUCH! -->
    <v-content class="mx-4 mt-4">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<style>
.v-pagination {
  width: auto !important;
}
</style>

<script>
import Menu from "@/components/Menu";

export default {
  name: "App",
  components: {
    Menu
  },
  data() {
    return {
      menu: {
        visible: true,
        mini: false
      }
    };
  },
  mounted() {
    this.$store.subscribe(mutation => {
      switch (mutation.type) {
        case "login":
          this.$router.push({ name: "home" });
          break;
        case "logout":
          this.$router.push({ name: "login" });
          break;
      }
    });
  }
};
</script>
